import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';


const initialState = {
  customStyling: {
    active: false,
    color: '',
    logo_url: '',
    game_name: '',
  },
};

export const AppStore = signalStore(
  {
    providedIn: 'root'
  },
  withState(initialState),
  withMethods(
    (store) => (
      {
        setCustomStyling(data: any): void{
          patchState(
            store, 
            (s) => {
              if (!data) {
                return s;
              }
              const r = document.querySelector(':root')! as HTMLElement;

              if (data.active && data.color) {
                let color = data.color;

                if (color.at(0) !== '#') color = `#${ color }`;
                
                if (color.length > 9) {
                  color = color.substring(0, 9);
                }
                r.style.setProperty('--color-primary', color);
              }
              
              return {
                ...s,
                customStyling: data
              };
            }
          );
        },
      }
    )
  )
);
